import React from 'react';
import './ContactPersons.scss';

const ProductDetails = ({ productDetails }) => {
	return (
		<div>
			<div>
				<div>
					<div
						className="d-flex"
						style={{ gap: '50px' }}
					>
						<div>
							<div
								style={{
									color: '#000',
									fontSize: '17px',
								}}
							>
								To Be Shipped
							</div>
							<div
								style={{
									color: '#000',
									fontSize: '18px',
									fontWeight: '600',
									lineHeight: '30px',
									textAlign: 'center',
								}}
							>
								{productDetails?.order_quantity || 'N/A'}
							</div>
						</div>
						<div style={{ borderRight: '1px solid #C3CBDC' }}></div>
						<div>
							<div
								style={{
									color: '#000',
									fontSize: '17px',
								}}
							>
								To Be Received
							</div>
							<div
								style={{
									color: '#000',
									fontSize: '18px',
									fontWeight: '600',
									lineHeight: '30px',
									textAlign: 'center',
								}}
							>
								{productDetails?.to_be_received_quantity}
							</div>
						</div>
					</div>
					<br />
					<div
						style={{
							border: '1px solid #D0D0D0',
							borderRadius: '8px',
							padding: '16px',
							maxWidth: '100%',
							fontFamily: 'Arial, sans-serif',
						}}
					>
						<h3
							style={{ borderBottom: '1px solid #D0D0D0', paddingBottom: '8px', fontWeight: '600' }}
						>
							Physical Stock Details
						</h3>
						<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
							<div className="ListQ">Stock on Hand</div>
							<div>{productDetails?.stock_on_hand}</div>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
							<div className="ListQ">Committed Stock</div>
							<div>{productDetails?.commited_stock}</div>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
							<div className="ListQ">Available for Sale</div>
							<div>{productDetails?.available_stock}</div>
						</div>
					</div>
					<br />
					<div
						style={{
							border: '1px solid #D0D0D0',
							borderRadius: '8px',
							padding: '16px',
							maxWidth: '100%',
							fontFamily: 'Arial, sans-serif',
						}}
					>
						<h3
							style={{ borderBottom: '1px solid #D0D0D0', paddingBottom: '8px', fontWeight: '600' }}
						>
							Accounting Stock Details
						</h3>
						<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
							<div className="ListQ">Stock on Hand</div>
							<div>{productDetails?.stock_on_hand}</div>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
							<div className="ListQ">Committed Stock</div>
							<div>{productDetails?.commited_stock}</div>
						</div>
						<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
							<div className="ListQ">Available for Sale</div>
							<div>{productDetails?.available_stock}</div>
						</div>
					</div>
					<br />
				</div>
			</div>
		</div>
	);
};

export default ProductDetails;
